var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLinkAddress = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44611_63319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18748 2.5C2.18748 1.36091 3.1109 0.4375 4.24998 0.4375H9.49998C10.6391 0.4375 11.5625 1.36091 11.5625 2.5V7.75C11.5625 8.88909 10.6391 9.8125 9.49998 9.8125H4.24998C3.1109 9.8125 2.18748 8.88909 2.18748 7.75V2.5ZM4.24998 1.5625C3.73222 1.5625 3.31248 1.98223 3.31248 2.5V7.75C3.31248 8.26777 3.73222 8.6875 4.24998 8.6875H9.49998C10.0178 8.6875 10.4375 8.26777 10.4375 7.75V2.5C10.4375 1.98223 10.0178 1.5625 9.49998 1.5625H4.24998ZM1 3.68744C1.31066 3.68744 1.5625 3.93928 1.5625 4.24994V7.99994C1.5625 9.34613 2.65381 10.4374 4 10.4374H7C7.31066 10.4374 7.5625 10.6893 7.5625 10.9999C7.5625 11.3106 7.31066 11.5624 7 11.5624H4C2.03249 11.5624 0.4375 9.96745 0.4375 7.99994V4.24994C0.4375 3.93928 0.68934 3.68744 1 3.68744Z",
    fill: "#007580"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44611_63319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLinkAddress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_link_address.0e6bff4db412873f6605a7020a296b05.svg";